import React from 'react';
import { Exercice, Mouvement } from '@mairistem/comptabilite';
import MouvementDeleteModal from './MouvementDeleteModal';
import DuplicationModal from '../../Bordereau/Modals/DuplicationModal';
import MouvementActionType from '../../../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';

interface MouvementModalProviderProps {
  treeViewAction: any;
  onChange: any;
  mouvement: Partial<Mouvement>;
  exercice: Exercice;
  typePes?: string;
}

const MouvementModalProvider = ({
  treeViewAction,
  mouvement,
  onChange,
  exercice,
  typePes,
}: MouvementModalProviderProps) => {
  const [data, setData] = React.useState<any>(treeViewAction.extraProps);

  const handleCloseModal = (modalName: string): void => {
    setData((old) => ({ ...old, [modalName]: { visible: false } }));
  };

  React.useEffect(() => {
    setData(treeViewAction.extraProps);
  }, [treeViewAction.extraProps]);

  const isSuperUser: boolean = data?.isSuperUser;

  if (data?.deleteModal?.visible) {
    return (
      <MouvementDeleteModal
        isSuperUser={isSuperUser}
        onClose={() => handleCloseModal('deleteModal')}
        onChange={() => { onChange(MouvementActionType.DELETE, mouvement); }}
        visible={data.deleteModal?.visible}
      />
    );
  }

  if (data?.mouvementDuplicationModal?.visible) {
    return (
      <DuplicationModal
        visible={data.mouvementDuplicationModal?.visible}
        onValidate={(mouvementCree) => onChange(MouvementActionType.DUPLIQUER, mouvementCree)}
        onClose={() => handleCloseModal('mouvementDuplicationModal')}
        mouvement={mouvement}
        exercice={exercice}
        typePes={typePes}
      />
    );
  }

  return null;
};

export default MouvementModalProvider;
